//include 4
jQuery(function(){
    // Hide CTA when empty
    if($("#offer-badge-video-header").length == 1 && $(".dce-header .video-cta-content").length != 4){
        var $active = $(".dce-header .custom-video-switcher a.active");
        var activeId = $active.attr("id").split("-link");
        activeId = activeId[0];

        if($("#" + activeId + "-cta").length == 0){
            $("#offer-badge-video-header").hide();
        }
    }

    // Click Custom Video Switcher
    $('.dce-header .custom-video-switcher a').click(function(e) {
        e.preventDefault();

        var beforeSeason =  $(".dce-header .custom-video-switcher a.active").attr("id").split("-link");
        beforeSeason = beforeSeason[0];

        var $this = $(this);
        var itemSeason = $this.attr("id").split("-link");
        itemSeason = itemSeason[0];

        setTimeout(function () {
            $this.tooltipster('hide');
        }, 100);

        if(beforeSeason != itemSeason){
            // remove active-class on before Season
            $("#" + beforeSeason + "-link").removeClass("active");
            $("#" + beforeSeason + "-cta").removeClass("active");
            $("#" + beforeSeason + "-li").removeClass("active");

            if($("#" + beforeSeason + "-li .video-loader").length > 0){
                $("#" + beforeSeason + "-li .video-loader").hide();
            }

            // add active-class on new season
            $("#" + itemSeason + "-link").addClass("active");
            $("#" + itemSeason + "-cta").addClass("active");
            $("#" + itemSeason + "-li").addClass("active");

            // show/hide cta
            if($("#" + itemSeason + "-cta").length == 0){
                $("#offer-badge-video-header").hide();
            }
            else {
                if(!$("#offer-badge-video-header").is(":visible")){
                    $("#offer-badge-video-header").fadeIn(800);
                }
            }

            // play/pause Video
            if($("#" + beforeSeason + "-li").find("video").length > 0){
                var videoStatus = "pause";
                var beforeVideoId =  $("#" + beforeSeason + "-li").find("video").attr("id");
                var beforeVideo = document.getElementById(beforeVideoId);

                if(beforeVideo.paused){
                    videoStatus = "pause";
                }
                else {
                    videoStatus = "play";
                    beforeVideo.pause();
                }

                if(videoStatus == "play"){
                    playPauseVideo(document.getElementById(itemSeason));
                }
                else{
                    $("#" + itemSeason + "-li .icon-play").show();
                    $("#" + itemSeason + "-li .teaser-box").show();
                }

                var videoId =  $("#" + itemSeason + "-li").find("video").attr("id");
                var video = document.getElementById(videoId);
            }
        }
    });

    $('.dce-header .video-wrapper').click(function(e) {
        var videoId = $(this).find(">.header-video").attr("id");
        playPauseVideo(document.getElementById(videoId));
    });
});

function playPauseVideo($video) {
    if ($video.paused){
        $(".dce-header .video.active .video-loader").show();

        if ($video.readyState >= $video.HAVE_FUTURE_DATA) {
            $(".dce-header .video.active .video-loader").hide();
        } else {
            $video.addEventListener('canplay', function () { // playing, oncanplaythrough, oncanplay
                $(".dce-header .video.active .video-loader").hide();
            }, false);
        }

        $video.play();

        window.pixelpoint.tagManager.event("Header-Video spielbeginn",{});

        
        var endedEventFunction = function(){
            $video.currentTime = 0;
            $video.pause();
            $(".dce-header .video.active .video-wrapper .icon-play").show();
            $(".dce-header .video.active .teaser-box").show();

            window.pixelpoint.tagManager.event("Header-Video abgespielt",{});
        };
        
        //$video.removeEventListener('ended',endedEventFunction,true);
        //$video.addEventListener('ended', endedEventFunction);
        $video.onended = endedEventFunction;

        //$('.dce-header .video-wrapper .icon-play').hide();
        $(".dce-header .video.active .video-wrapper .icon-play").hide();
        $(".dce-header .video.active .teaser-box").hide();
    }
    else {
        $video.pause();

        window.pixelpoint.tagManager.event("Header-Video pause",{});

        $(".dce-header .video.active .video-loader").hide();

        //$('.dce-header .video-wrapper .icon-play').show();
        $(".dce-header .video.active .video-wrapper .icon-play").show();
        $(".dce-header .video.active .teaser-box").show();
    }
}